import * as React from "react";

import {consumeContext} from "@Common/react/context";
import {makeChain}      from "@Common/react/cst2";
import {Types}          from "@Common/types";


export const IsBranchOrder = ({
    next: rootNext
}:{
    next            : (status:boolean) => JSX.Element,
}) => (

    makeChain<JSX.Element>()

    .then(...consumeContext("session")) // used by Xpresso to determine if branch order: uses session.value.isBranchOrder
    .then(...consumeContext("agent")) // used by APM to determine if branch order: empty agent.idPrimary

    .then(({session, agent}) => rootNext(session.value ? session.value.isBranchOrder : !agent.idPrimary))

    .run()

);
